// extracted by mini-css-extract-plugin
export default {"main":"PanelHeader_main__tMutx","icon":"PanelHeader_icon__mxzoC","title":"PanelHeader_title__q7Hmk"};